import { RestaurantService } from './../../service/restaurantManager/restaurant.service';
import { CatagoryService } from './../../service/catagoryService/catagory.service';
import { DishService } from './../../service/DishManager/dish.service';
import { FileUpload } from './../../service/FileUpload/fileUpload';
import { FileUploadService } from './../../file-upload.service';
import { Router, ActivatedRoute } from '@angular/router';
import {  FormBuilder } from '@angular/forms';
import { Component, OnInit} from '@angular/core';
import * as _ from "lodash";

@Component({
  selector: 'app-edit-dish',
  templateUrl: './edit-dish.component.html',
  styleUrls: ['./edit-dish.component.scss']
})
export class EditDishComponent implements OnInit {
  members:any;
  addForm:any;addAttributeForm:any;
  msg1:string;currentUpload:any;
msg:any;;
delete1:boolean=false;
allSelected = false;
allSelected1 = false;value:any;price:any;rrp:any;
selectedFile:File=null;path:string='DISHES';
id:any;
yes:boolean= true;
no:boolean=false;
catagories:any=[];
edit1:any=false;restaurants:any;
simple:any="simple"
    constructor(private activeRoute:ActivatedRoute,private route:Router,private restaurantService:RestaurantService,private ApiService:DishService,private catagoryService:CatagoryService, private fb:FormBuilder,private UploadService:FileUploadService) {
      this.addForm={
        status:true,
        image:{url:""},
        attribute:[],
        popular:false,
        catagories:[],
        subcatagories:[]
      }
      this.id=this.activeRoute.snapshot.paramMap.get('id');
  this.getCatagories();
this.getDishDetail();this.getRestaurants();
     }
     getRestaurants()
     {
   this.restaurantService.getRestaurants().then((res)=>
   {
     this.restaurants=res;
     console.log(this.restaurants)
   })
     }
     change()
     {
      console.log(this.simple)
     }
     getDishDetail()
     {
       this.ApiService.getDishDetail(this.id).then((res)=>
       {
         this.addForm=res
         console.log(this.addForm)
       })
     }

  ngOnInit(): void {
  }
  getCatagories()
  {
    this.catagoryService.getCatagories().then((res)=>
    {
this.catagories=res
console.log(this.catagories)
    })
  }
  deleteAttribute(i)
  {
        this.addForm.attribute=this.addForm.attribute.filter(function(el){ return el.id != i; });;
  }

  edit(a)
  {
  
    this.addForm.attribute.forEach(element => {
      if(element.id==a)
      {
        console.log('ad')
        if(element.editStatus==true)
        {
        element.editStatus=false
          
        }
        else if(element.editStatus==false)
        {
          element.editStatus=true
        }
        console.log(element)
      }
    });
  }
  addAttribute()
  {
 if(this.price && this.rrp )
 {
    console.log("hi")
    this.addForm.attribute.push({ id: this.addForm.attribute.length + 1, price: this.price, retail_price:this.rrp,value:this.value,editStatus:false })
    console.log(this.addForm.attribute)
    this.price='';
    this.rrp='';
    this.value=''
    this.msg=null;
  }
  else
  {
    this.msg="enter valid";
  }  
  }
 

  
  paymentChange(education1) {
   
   

    console.log(education1);
   this.addForm.paymentOption=education1;
   console.log(this.addForm);
  }
  offerChange(education1) {
   console.log(education1);
   this.addForm.offerCode=education1;
   console.log(this.addForm);
  }
  showPreview(event:any)
  {
    if(event.target.files && event.target.files[0])
    {
      // const reader=new FileReader();
      //   reader.onload=(e:any)=>this.addForm.image.url=e.target.result;
      //   reader.readAsDataURL(event.target.files[0]);
        this.selectedFile=event.target.files[0];
        // console.log(this.selectedFile);
      this.detectFiles();
    }
    else
    {
      this.addForm.image.url="https://www.linuxtrainingacademy.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png";
    }
  }
  detectFiles() {
    // this.deletePreviousFile();
    // this.addForm.image={'url':"https://i.ibb.co/4774fvj/profileimg.png"}
    // this.currentUpload=null;
    this.uploadSingle();
  } 
  uploadSingle()
  {
    this.currentUpload = new FileUpload(this.selectedFile);
    console.log(this.currentUpload);
    this.UploadService.pushUpload(this.currentUpload,this.path).then((res) => {
      this.addForm.image = res;
      this.delete1=true
      
      this.currentUpload=null;
      console.log(this.addForm.image);
      console.log(this.UploadService.uploadPercentage);
    });
  }
  delete()
  {
    this.deletePreviousFile();
    
  }
  deletePreviousFile()
  {
    if(this.addForm.image.name!=undefined)
    {
      this.UploadService.deleteUpload(this.addForm.image,this.path).then((res)=>
      {
        
        console.log('Previous Image Deleted');
       this.addForm.image={}
this.delete1=false
        this.currentUpload=null;
      this.delete1=false

      }).catch((error)=>
      {
        this.addForm.image={}
      })
    }
  }
  updateDish()
  {
    // this.addForm.catagory_id.forEach(element => {
    //   if(element.parent_id)
    //   {
    //     this.addForm.subcatagories.push(element.id)
    //   }
    //   else
    //   {
    //     this.addForm.catagories.push(element.id)
    //   }
    // });
    // for( var i=this.addForm.catagories.length - 1; i>=0; i--){
    //   for( var j=0; j<this.addForm.subcatagories.length; j++){
    //       if(this.addForm.catagories[i] && (this.addForm.catagories[i] === this.addForm.subcatagories[j])){
    //           this.addForm.catagories.splice(i, 1);
    //       }
    //   }
    // }
  
   this.ApiService.EditDishDetail(this.id,this.addForm).then(
      (res)=>
      {
        console.log(res);
        console.log("dish is updated");
        this.route.navigateByUrl('/dashboard/dishes')
      }
    );

  console.log(this.addForm);
    }
  }

